import { Component } from '@angular/core';
import { DataService } from '../data.service';
import { ActivatedRoute } from '@angular/router';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-form-usuarios',
  templateUrl: './form-usuarios.component.html',
  styleUrls: ['./form-usuarios.component.css']
})
export class FormUsuariosComponent {
  usuarios;
  hayUsuarios: boolean = true;
  crearusuario: boolean = false;
  editarusuario: boolean = false;
  idUsuario: string;
  Usuario: any;


  encuestas;
  opciones = [ ];
  opcionSeleccionada: any = null;
  constructor(public data: DataService, private route: ActivatedRoute, private messageService: MessageService) {

    
    this.data.encuestaSeleccionada$.subscribe(valor => {
      this.opcionSeleccionada = valor ?? '';
      console.log('Nuevo valor seleccionado:', this.opcionSeleccionada);
      // Aquí puedes actualizar la vista o realizar otra acción
      this.ObtenerUsuarios();
    });



   }

   ObtenerUsuarios() {
    this.data.ObtenerUsuarios(this.opcionSeleccionada).subscribe(
      {
        next: (x) => 
          {      
            this.usuarios = x;
            console.log("================USUARIOS RECIBIDOS================");
            console.log(x);
          },
          error: (error) => {
          //si error es 404, no hay encuestas 
          if (error.status === 404) {
            console.log('No hay usuarios');
            this.hayUsuarios = false;
          }
          else
          {
            console.error('Error al listar usuarios:', error);
            console.log(error);
          }
        }
      });
  }

  onCrearUsuario() {
    this.crearusuario = true;
  }

  onCreacionFinalizada() {
    this.crearusuario = false; // Oculta el componente de creación
    this.ObtenerUsuarios();
  }

  onEdicionFinalizada() {
    this.editarusuario = false; // Oculta el componente de edición
    this.idUsuario = null;
    this.ObtenerUsuarios();
  }

  navigateToUsuario(id: string) {
    console.log('navegando a encuesta:', id);

    //this.router.navigate(['/encuesta', id]);
    this.editarusuario = true;
    this.idUsuario = id;
    this.Usuario = this.usuarios.find(x => x._id === id);
  }

  navigateToCrearContrasena(id: string) {
    this.messageService.add({severity:'info', summary: 'Información', detail: 'http://goyn.disweb.co/crearcontrasena/' + id});
  }

}
